import blake from 'blakejs';
import { sha256 } from './sha256';
// return n-byte Uint8Array
const blake2b = blake.blake2b;
function blake2b512(input, key) {
    return blake2b(input, key, 64);
}
// THash calculates sha256(blake2b-512(b))
// and returns the resulting bytes as a Hash
export default function THash(input) {
    let first = blake2b512(input);
    return sha256(first);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVEhhc2guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL3V0aWxzL1RIYXNoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBSyxNQUFNLFNBQVMsQ0FBQTtBQUMzQixPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sVUFBVSxDQUFBO0FBRWpDLDJCQUEyQjtBQUMzQixNQUFNLE9BQU8sR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFBO0FBRTdCLFNBQVMsVUFBVSxDQUFDLEtBQWEsRUFBRSxHQUFnQjtJQUNqRCxPQUFPLE9BQU8sQ0FBQyxLQUFLLEVBQUUsR0FBRyxFQUFFLEVBQUUsQ0FBQyxDQUFBO0FBQ2hDLENBQUM7QUFFRCwwQ0FBMEM7QUFDMUMsNENBQTRDO0FBQzVDLE1BQU0sQ0FBQyxPQUFPLFVBQVUsS0FBSyxDQUMzQixLQUFhO0lBRWIsSUFBSSxLQUFLLEdBQUcsVUFBVSxDQUFDLEtBQUssQ0FBQyxDQUFBO0lBQzdCLE9BQU8sTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFBO0FBQ3RCLENBQUMifQ==